export const executions = $axios => ({
  create: params => $axios.$post('/workflow_executions', params),
});
